var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"fab":_vm.fab,"large":_vm.large,"x-large":_vm.xlarge,"absolute":_vm.absolute,"width":_vm.width,"height":_vm.height,"color":_vm.color,"depressed":_vm.depressed},on:{"click":function($event){return _vm.eventClick()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }